<div class="tap-top" [ngStyle]="{ 'display': show ? 'block' :'none' }" (click)="backToTop()">
    <app-feather-icon [icon]="'chevrons-up'"></app-feather-icon>
</div>